import React, { useState } from "react";
import api from "../api/api";
import "./Login.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const currentYear = new Date().getFullYear();

  const submit = async e => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const form = new FormData();
      form.append("username", email);
      form.append("password", password);

      const res = await api.post("/auth/login", form);
      localStorage.setItem("token", res.data.access_token);
      window.location.href = "/";
    } catch (_err) {
      setError("Credenciais inválidas. Verifique e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-panel">
        <img src="/logo_magma.png" alt="Magma Planning" className="login-logo" />
        <p className="login-kicker">Gerenciador de Planejamento</p>
        <h1 className="login-title">Magma Planning</h1>
        <p className="login-subtitle">Acesse seu workspace para acompanhar planejamentos e resultados.</p>

        <form className="login-form" onSubmit={submit}>
          <label className="login-label" htmlFor="email">
            E-mail
          </label>
          <input
            id="email"
            className="login-input"
            type="email"
            placeholder="Seu e-mail"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />

          <label className="login-label" htmlFor="password">
            Senha
          </label>
          <input
            id="password"
            className="login-input"
            type="password"
            placeholder="Sua senha"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />

          {error ? <p className="login-error">{error}</p> : null}

          <button className="login-button" type="submit" disabled={loading}>
            {loading ? "Entrando..." : "Entrar no sistema"}
          </button>
        </form>
      </section>
      <footer className="login-footer">
        Copyright © {currentYear} Magma Consultoria. Todos os direitos reservados.
      </footer>
    </main>
  );
}
